import { render, staticRenderFns } from "./ContentDownloads.vue?vue&type=template&id=048e64ba&scoped=true&"
import script from "./ContentDownloads.vue?vue&type=script&lang=js&"
export * from "./ContentDownloads.vue?vue&type=script&lang=js&"
import style0 from "./ContentDownloads.vue?vue&type=style&index=0&id=048e64ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e64ba",
  null
  
)

export default component.exports